type Props = {
  label: string;
};

const Perk: React.FC<Props> = ({ label }) => {
  return (
    <div className={"pl-2 flex items-center"}>
      <span className={"text-2xl leading-none font-comic"}>☑&nbsp;</span>
      {label}
    </div>
  );
};

export default Perk;
